// BabyFirstStride — scripts propios (vanilla, sin librerías)

function bfsInitReveal() {
  const items = document.querySelectorAll('.bfs-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((el) => el.classList.add('bfs-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bfs-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach((el) => observer.observe(el));
}

function bfsInitGalerias() {
  document.querySelectorAll('[data-bfs-galeria]').forEach((galeria) => {
    const principal = galeria.querySelector('[data-bfs-principal]');
    const thumbs = galeria.querySelectorAll('[data-bfs-thumb]');
    if (!principal || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
}

function bfsInitPacks() {
  document.querySelectorAll('[data-bfs-packs]').forEach((wrap) => {
    const packs = wrap.querySelectorAll('[data-bfs-pack]');
    const form = wrap.closest('form');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    const color2Wrap = form?.querySelector('[data-bfs-color2-wrap]');
    const addBtn = form?.querySelector('[data-bfs-add]');
    const productoRoot = wrap.closest('.bfs-producto');
    const shipSingleEls = productoRoot ? productoRoot.querySelectorAll('[data-bfs-ship-single]') : [];
    const shipBogoEls = productoRoot ? productoRoot.querySelectorAll('[data-bfs-ship-bogo]') : [];
    if (!packs.length || !qtyInput) return;

    packs.forEach((pack) => {
      pack.addEventListener('click', () => {
        packs.forEach((p) => p.classList.remove('is-selected'));
        pack.classList.add('is-selected');
        const qty = parseInt(pack.getAttribute('data-qty') || '1', 10);
        qtyInput.value = qty;
        if (color2Wrap) {
          color2Wrap.hidden = qty < 2;
          const color2Select = color2Wrap.querySelector('select');
          if (color2Select) color2Select.disabled = qty < 2;
        }
        shipSingleEls.forEach((el) => { el.hidden = qty >= 2; });
        shipBogoEls.forEach((el) => { el.hidden = qty < 2; });
        const cta = pack.getAttribute('data-cta');
        if (addBtn && cta && !addBtn.disabled) addBtn.textContent = cta;
      });
    });
  });
}

function bfsInitColorSwatches() {
  document.querySelectorAll('[data-bfs-colors]').forEach((wrap) => {
    const pills = wrap.querySelectorAll('[data-bfs-color]');
    const form = wrap.closest('form');
    const colorInput = form?.querySelector('[data-bfs-color-input]');
    const variantInput = form?.querySelector('[data-bfs-variant-id]');
    const label = form?.querySelector('[data-bfs-color-label]');
    const gallery = form?.closest('.bfs-producto')?.querySelector('[data-bfs-galeria]');
    const principal = gallery?.querySelector('[data-bfs-principal]');
    const thumbs = gallery ? gallery.querySelectorAll('[data-bfs-thumb]') : [];

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');

        const name = pill.getAttribute('data-name') || '';
        const full = pill.getAttribute('data-full');
        const variantId = pill.getAttribute('data-variant-id');

        if (colorInput) colorInput.value = name;
        if (variantInput && variantId) variantInput.value = variantId;
        if (label) label.textContent = name;
        if (principal && full) principal.src = full;
        thumbs.forEach((t) => t.classList.remove('is-active'));
      });
    });
  });
}

function bfsInitCountdown() {
  document.querySelectorAll('[data-bfs-countdown]').forEach((el) => {
    const h = el.querySelector('[data-bfs-h]');
    const m = el.querySelector('[data-bfs-m]');
    const s = el.querySelector('[data-bfs-s]');
    if (!h || !m || !s) return;

    const pad = (n) => String(n).padStart(2, '0');

    function tick() {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      let diff = Math.max(0, midnight - now);
      const hours = Math.floor(diff / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      h.textContent = pad(hours);
      m.textContent = pad(mins);
      s.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function bfsInitCartReserva() {
  const el = document.querySelector('[data-bfs-reserva-reloj]');
  if (!el) return;

  const DURATION_MS = 10 * 60 * 1000;
  const KEY = 'bfs_cart_reserva_deadline';

  let deadline = Number(sessionStorage.getItem(KEY) || 0);
  if (!deadline || deadline < Date.now()) {
    deadline = Date.now() + DURATION_MS;
    sessionStorage.setItem(KEY, String(deadline));
  }

  function tick() {
    const target = document.querySelector('[data-bfs-reserva-reloj]');
    if (!target) return;
    const diff = Math.max(0, deadline - Date.now());
    const mins = Math.floor(diff / 60000);
    const secs = Math.floor((diff % 60000) / 1000);
    target.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    if (diff <= 0) {
      sessionStorage.removeItem(KEY);
    }
  }

  tick();
  setInterval(tick, 1000);
}

function bfsInitResenaCarrusel() {
  document.querySelectorAll('[data-bfs-resena-carrusel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-bfs-resena-track]');
    const slides = track ? [...track.children] : [];
    const dots = [...wrap.querySelectorAll('[data-bfs-resena-puntos] .bfs-mini-resena-punto')];
    if (!track || slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    const total = slides.length;
    let timer = null;
    let dragging = false;
    let dragStartX = 0;
    let dragDeltaX = 0;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = `translateX(calc(-${index * 100}% + var(--bfs-drag-offset, 0px)))`;
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    }

    function stopAuto() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function startAuto() {
      if (reduceMotion) return;
      stopAuto();
      timer = setInterval(() => goTo(index + 1), 5000);
    }

    dots.forEach((dot, di) => {
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', () => {
        goTo(di);
        startAuto();
      });
    });

    track.style.setProperty('--bfs-drag-offset', '0px');
    track.style.touchAction = 'pan-y';

    track.addEventListener('pointerdown', (e) => {
      dragging = true;
      dragStartX = e.clientX;
      dragDeltaX = 0;
      stopAuto();
      track.style.transition = 'none';
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      dragDeltaX = e.clientX - dragStartX;
      track.style.setProperty('--bfs-drag-offset', `${dragDeltaX}px`);
      track.style.transform = `translateX(calc(-${index * 100}% + ${dragDeltaX}px))`;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      track.style.setProperty('--bfs-drag-offset', '0px');
      const threshold = 50;
      if (dragDeltaX > threshold) {
        goTo(index - 1);
      } else if (dragDeltaX < -threshold) {
        goTo(index + 1);
      } else {
        goTo(index);
      }
      startAuto();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', () => { if (dragging) endDrag(); });

    startAuto();
  });
}

function bfsInitCantidad() {
  document.querySelectorAll('[data-bfs-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const menos = wrap.querySelector('[data-qty-menos]');
    const mas = wrap.querySelector('[data-qty-mas]');
    if (!input) return;

    menos?.addEventListener('click', () => {
      const val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });
    mas?.addEventListener('click', () => {
      const val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bfsInitReveal();
  bfsInitGalerias();
  bfsInitColorSwatches();
  bfsInitPacks();
  bfsInitCantidad();
  bfsInitCountdown();
  bfsInitCartReserva();
  bfsInitResenaCarrusel();
}, { once: true });
